import { Experiment } from 'modules/domains/campaign';
import { useExperimentTakeover } from 'modules/experiments/takeover';
import { ExperimentTakeoverSource } from 'modules/experiments/takeover/constants';
import { WebLink2 } from 'ui/theme';

export const SAVED_EXPERIMENT_TAKEOVER = 'saved-experiment-takeover';

export const ExperimentLink = ({ experiment }: { experiment: Experiment }) => {
  const { getExperimentLinkAttributes } = useExperimentTakeover();

  const { name } = experiment;

  const attributes = getExperimentLinkAttributes({
    source: ExperimentTakeoverSource.CAMPAIGN_EDITOR,
    experiment,
  });

  return (
    <WebLink2 data-test={SAVED_EXPERIMENT_TAKEOVER} {...attributes}>
      {name}
    </WebLink2>
  );
};
